// extracted by mini-css-extract-plugin
export var locationCard = "_ho-0";